module.exports = __webpack_public_path__ + "static/media/profile.db657b12.png";